import { computed, ComputedRef } from 'vue'
import { generateQuantityOptions } from '@/utils/quantityOptions'

/**
 * Vue composable for generating quantity options based on a product's carton size.
 * Follows DRY principle by centralizing quantity dropdown logic.
 */
export function useQuantityOptions(cartonQuantity = 1, isPos = false, maxOrderable?: number | null): {
  quantityOptions: ComputedRef<number[]>
} {
  const quantityOptions = computed(() => {
    return generateQuantityOptions(cartonQuantity, isPos, maxOrderable)
  })

  return {
    quantityOptions
  }
}
